import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IStandortsQueryShapes, StandortsQueryFilterConfig } from 'fa-kt.types';
import { StandortsService } from '../service';

@Component({
  selector: 'fa-kt-standorts-filter',
  templateUrl: './standorts-filter.component.html',
  styleUrls: ['./standorts-filter.component.css'],
})
export class StandortsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  StandortsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public standorts: StandortsService,
  ) {
    this.StandortsFilterConfig = StandortsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.standorts.shapes$.subscribe((shapes: IStandortsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.StandortsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.StandortsFilterConfig[index].selections = shapes;
  }
}
